import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconCloud,
  IconAi,
  IconSchool,
  IconShieldCheck,
} from '@tabler/icons-react';

const homePageFeatures: FeatureData[] = [
  {
    title: '',
    description: '',
    icon: <IconCloud size={24} />,
    key: 'features.cloudServices'
  },
  {
    title: '',
    description: '',
    icon: <IconShieldCheck size={24} />,
    key: 'features.cybersecurity'
  },
  {
    title: '',
    description: '',
    icon: <IconAi size={28} />,
    key: 'features.cyberwar'
  },
  {
    title: '',
    description: '',
    icon: <IconSchool size={24} />,

    key: 'features.itTraining'
  }
];

export default homePageFeatures; 